module.exports = __webpack_public_path__ + "static/media/ellipsis-v.9ec21caf.svg";